(function () {
    // prettier-ignore
    var relatedViewTemplate =
            '<div class="slide-wrap ui_carousel_slider component-product__carousel relate-list">' +
                '<div class="slide-content ui_carousel_list"><!-- 연관제품의 수가 2개 이상일 때 .slide-content에 .multi-slide 클래스 추가 -->' +
                    '<div class="slide-track ui_carousel_track">' +
                        '<!-- slide -->' +
            '{{#each (prod, index) in gramPlusViewProductInfoList}}' +
                        '<div class="slide-conts ui_carousel_slide">' +
                            '<div class="relate-product">' +
                                '<div class="thum">' +
                                    '<a href="{{prod.modelUrlPath}}">' +
                                        '<img src="{{prod.mediumImageAddr}}" alt="">' +
                                    '</a>' +
                                '</div>' +
                                '<div class="product-info">' +
            '{{#if prod.newProductBadgeFlag == "Y"}}' +
                                    '<div class="flag-wrap">' +
                                        '<span class="flag">신제품</span>' +
                                    '</div>' +
            '{{/if}}' +
                                    '<div class="product-name">' +
                                        '<a href="{{prod.modelUrlPath}}"><span class="main-title"><span class="main">{{#raw prod.modelDisplayNamePlusSpec}}</span></span></a>' +
                                    '</div>' +
                                    '<div class="sku">{{prod.modelName}}</div>' +
                                    '<div class="price-area">' +
                                        '<div class="original">' +
                                            '<em class="blind">할인 전 정가</em>' +
                                            '<span class="price">{{prod.originalPrice}}원</span>' +
                                        '</div>' +
                                        '<div class="total">' +
                                            '<em class="blind">할인 후 판매가</em>' +
                                            '<span class="price">{{prod.salePrice}}원</span>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>' +
            '{{/each}}' +
                    '</div>' +
                '</div>' +
            '{{#if gramPlusViewProductInfoList.length > 2}}' +
                '<div class="slide-controls" style="display:block;">' +
                    '<button type="button" class="btn-arrow prev ui_carousel_prev"><span class="blind">이전</span></button>' +
                    '<button type="button" class="btn-arrow next ui_carousel_next"><span class="blind">다음</span></button>' +
                '</div>' +
            '{{/if}}' +
            '</div>';

    var relatedProductListTemplate =
        '{{#each (item, index) in relatedProductList}}' +
        '<li class="lists" data-ec-product="{{item.ecProductStr}}">' +
        '   <div class="list-inner">' +
        '       <a href="{{item.modelUrlPath}}">' +
        '           <span class="thumb"><img src="{{item.mediumImageAddr}}" alt=""></span>' +
        '           <div class="prod-info">' +
        '               <div class="prod-name"><span class="main-title"><span class="main">{{#raw item.modelDisplayNamePlusSpec}}</span></span></div>' +
        '               <div class="sku">{{item.modelName}}</div>' +
        '               <div class="price-area">' +
        '                   <div class="original">' +
        '                       <em class="blind">할인 전 정가</em>' +
        '                       <span class="price">{{item.originalPrice}}원</span>' +
        '                   </div>' +
        '                   <div class="total">' +
        '                       <em class="blind">할인 후 판매가</em>' +
        '                       <span class="price">{{item.salePrice}}원</span>' +
        '                   </div>' +
        '               </div>' +
        '           </div>' +
        '       </a>' +
        '   </div>' +
        '</li>' +
        '{{/each}}';

    var relatedProduct = {
        variable: {
            gramPlusViewProductInfo: null,
            relatedProductTypeCodeList: null
        },
        el: {
            $contents: null,
            $relProdWrap: null,
            $relProdCateWrap: null,
            $listSorting: null,
            $btnArea: null
        },
        selector: {
            relProdWrap: '.cont-wrap',
            relProdCateWrap: '.gray-full-box',
            listSorting: '.list-sorting',
            btnArea: '.btn-area'
        },
        init: function (el) {
            this.el.$contents = $(el);
            if (!this.el.$contents.length > 0) {
                return;
            }

            this.setProperty();
            this.bindEvents();
            this.requestRelatedProductList();
        },
        setProperty: function() {
            var $contents = this.el.$contents;

            // this.setParams('', 1, 'sort_new');
            $contents.data('relatedProductType', '00');
            $contents.data('page', 1);
            $contents.data('sortType', 'sort_new');

            this.el.$relProdWrap = $contents.find(this.selector.relProdWrap);
            this.el.$relProdCateWrap = $contents.find(this.selector.relProdCateWrap);
            this.el.$listSorting = $contents.find(this.selector.listSorting);
            this.el.$btnArea = $contents.find(this.selector.btnArea);
        },
        bindEvents: function() {
            var _self = this;

            this.el.$relProdCateWrap.on('click', 'ul.tabs > li', function(e) {
                _self.el.$contents.data('relatedProductType', $(this).data('code'));
                _self.el.$contents.data('page', 1);
                _self.requestRelatedProductList();
            });

            this.el.$btnArea.on('click', '#btnMoreView', function(e) {
                _self.el.$contents.data('page', parseInt(_self.el.$contents.data('page')) + 1);
                _self.requestRelatedProductList();
            });

            this.el.$listSorting.on('change', function(e) {
                _self.el.$contents.data('page', 1);
                _self.el.$contents.data('sortType', e.target.value);
                _self.requestRelatedProductList();
            });
        },
        handler: {},
        requestRelatedProductList: function() {
            var url = this.el.$contents.data("related-list");
            var params = {
                relatedProductType: this.el.$contents.data('relatedProductType'),
                page: this.el.$contents.data('page'),
                sortType: this.el.$contents.data('sortType')
            };

            lgkorUI.showLoading();
            lgkorUI.requestAjaxDataPost(
                url,
                params,
                function (result) {
                    if (result.status == "fail") {
                        lgkorUI.alert("", {
                            title: result.message,
                        });
                    } else {
                        var isEmptyPlusViewList = !$.trim($(".relate-list").html());
                        // 연관상품(플러스뷰)
                        if (result.data[0].gramPlusViewProductInfoList && result.data[0].gramPlusViewProductInfoList.length > 0 && isEmptyPlusViewList) {
                            var gramPlusViewProductInfoList = result.data[0].gramPlusViewProductInfoList;
                            gramPlusViewProductInfoList.forEach(function(item, index) {
                                item.salePrice = vcui.number.addComma(item.salePrice);

                                if (Object.keys(item.ecProductInfo || {}).length > 0) {
                                    item.ecProductInfo.price = (item.ecProductInfo.price && item.ecProductInfo.price > 0) ? String(item.ecProductInfo.price) : "";
                                    item.ecProductStr = JSON.stringify(item.ecProductInfo);
                                }
                            });
                            this.setGramPlusView(result);
                            this.plusViewInit();
                        }
                        // 연관상품 카테고리
                        if (vcui.isEmpty(this.variable.relatedProductTypeCodeList)) {
                            this.variable.relatedProductTypeCodeList = result.data[0].relatedProductTypeCodeList;
                            if (!vcui.isEmpty(this.variable.relatedProductTypeCodeList)) this.setCategoryTags();
                        }
                        var page = parseInt(result.data[0].pagination.page);
                        var totalcnt = parseInt(result.data[0].pagination.totalCount);

                        // 연관상품
                        if (result.data[0].relatedProductList && result.data[0].relatedProductList.length > 0) {
                            var relatedProductList = result.data[0].relatedProductList;
                            relatedProductList.forEach(function(item, index) {
                                item.salePrice = vcui.number.addComma(item.salePrice);

                                if (Object.keys(item.ecProductInfo || {}).length > 0) {
                                    item.ecProductInfo.price = (item.ecProductInfo.price && item.ecProductInfo.price > 0) ? String(item.ecProductInfo.price) : "";
                                    item.ecProductStr = JSON.stringify(item.ecProductInfo);
                                }
                            });

                            this.el.$relProdCateWrap.find('.no-data').css('display', 'none');
                            if(page == 1) {
                                this.el.$contents.find('.box-list-inner').empty();
                            }
                            this.el.$relProdCateWrap.find('.box-list-inner').append(this.convert(vcui.template(relatedProductListTemplate,result.data[0])));

                            // 총 갯수
                            this.setTotalCount(result.data[0].listTotalCount);

                        } else {
                            this.el.$contents.find('.box-list-inner').empty();
                            this.el.$relProdCateWrap.find('.no-data').css('display', 'block');
                            this.setTotalCount(0);
                        }

                        // 더보기 활성화
                        if(page == totalcnt || totalcnt == 0) this.el.$contents.find('.btn-area').css('display','none');
                        else this.el.$contents.find('.btn-area').css('display','block');

                    }

                    lgkorUI.hideLoading();

                    this.pushDataLayer();
                }.bind(this),
                true
            );

        },
        setGramPlusView: function(result) {
            this.el.$relProdWrap.find('.box-tit-wrap').after(vcui.template(relatedViewTemplate, result.data[0]));
        },
        setCategoryTags: function() {
            this.el.$relProdCateWrap.find('.ui_tab').vcTab();
            this.el.$relProdCateWrap.find('.ui_tab').vcSmoothScroll();
        },
        setTotalCount: function(data) {
            this.el.$listSorting.find('#totalCount').html('총 <em>' + data + '</em>개');
        },
        // GA 태그 호출 (동적 html 생성이후 호출)
        pushDataLayer: function() {
            if(typeof dataLayer !== 'undefined' && dataLayer) {
                dataLayer.push({'event': 'microPlpOpen'});
            }
        },

        // BTOCSITE-19564 렛츠그램 2차
        plusViewInit: function(){

            var self = this;
            self.$carousel = $('.ui_carousel_slider.relate-list');
            self.$slideContent = $('.ui_carousel_slider.relate-list .slide-content');
            self.$slideConts = $('.ui_carousel_slider.relate-list .slide-conts');
            self.$slideControls = $('.ui_carousel_slider.relate-list .slide-controls');
            self.$carousel.data('isCarousel',false);
            if(self.$slideConts.length >= 2){
                self.$slideContent.addClass('multi-slide');
            }
            if(self.$slideConts.length >= 2){
                self.plusViewBindEvents();
            }
            if(self.$slideConts.length < 2){
                self.$carousel.css('visibility','visible');
                self.$slideControls.hide();
            }
        },
        setCarousel:function(){
            var self = this;
            if(self.$slideConts.length >= 2){
                self.$carousel.vcCarousel({
                    infinite: false,
                    slidesToScroll: 1,
                    slidesToShow: 2,
                });
                self.$carousel.data('isCarousel',true);
                self.$carousel.css('visibility','visible')
            }else{
                self.$slideControls.hide();
            }
        },
        plusViewBindEvents: function() {
            var self = this;
            var $window = $(window);

            $window.on('resizeend', function(){
                self.$carousel.css('visibility','hidden');
                if (window.innerWidth < 768) {
                    if(self.$carousel.data('isCarousel') === true){
                        self.$carousel.vcCarousel('instance') && self.$carousel.vcCarousel('instance').destroy();
                        self.$carousel.data('isCarousel',false);
                    }
                    self.$slideContent.css('overflow-x','auto');
                    self.$carousel.css('visibility','visible');
                } else {
                    self.setCarousel();
                }
            }).trigger('resizeend');
        },

        convert : function(str) {
            str = str.replace(/&lt;/g, '<');
            str = str.replace(/&gt;/g, '>');
            return str;
        }
    };



    $(window).ready(function () {
        relatedProduct.init('.contents.gram-cont');
    });
})();
